import {  useRef } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import {
  Text,
  PerspectiveCamera,
  OrbitControls,
  Center,
} from "@react-three/drei";
import allColors from './Colors'
import * as THREE from 'three'
let lerp = THREE.MathUtils.lerp
let randI = (i) => Math.floor(i * fxrand())
let rand = (arr) => arr[randI(arr.length)]
function shuffle(array) {
  let currentIndex = array.length, randomIndex;
  while (currentIndex != 0) {
    randomIndex = Math.floor(fxrand() * currentIndex);
    currentIndex--;
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }
  return array;
}
let ci = randI(allColors.length)
let cols = allColors[ci]
console.log(cols)
let bg = cols.shift()
shuffle(cols)

let started = false
let chars = "'\:-.:..,.,,;_-=\"|"
let gs = rand([0.25])
let layers = rand([2,3,3,3,3,4,4,4,5])
console.log(gs, layers)
let letters = new Array(Math.ceil(layers)).fill().map(() => new Array(1+randI(10)).fill().map(() => rand(chars)))
let sizes = letters.map(() => rand([0.25, 0.25, 0.125, 0.25, 0.5, 0.125, 1]) * 0.25 * gs)
let offsets = letters.map(() => (randI(10) * 0.1) * rand([1, -1]))
export default function App() {
  const click = () => {
    started = true
  }
  return (
    <div id="main" onClick={() => click()} >
      <Canvas flat={true} linear={true}>
        <color attach="background" args={[bg]} />
        <PerspectiveCamera position={[0.5 * rand([1, -1,0]), 0.5 * rand([1, -1,0]), 1.1]} near={0.0001} fov={25} makeDefault />
        <Center>
          {letters.map((l, i) =>
            <group position={[0, 0, 0]}>
              <Typography l={l} i={i} />
            </group>
          )}
        </Center>
        <OrbitControls enablePan={false} enableRotate={false} maxDistance={3} minDistance={0.2}  />
      </Canvas>
    </div>
  );
}
let mat = new THREE.MeshBasicMaterial({
  depthTest: false,
  blending: THREE.CustomBlending,
  blendEquation: THREE.AddEquation,
  blendSrc: THREE.SrcColorFactor,
  blendDst: THREE.OneMinusSrcColorFactor
})
let textSize = 0.3
let time = randI(500)
const Typography = ({ l, i }) => {
  const text = useRef();
  const group = useRef();
  const pos = useRef(0);
  useFrame((s,d) => {
    if(started){
      pos.current += d*0.1
      group.current.position.x = lerp(group.current.position.x, Math.sin(pos.current)*0.2, 0.0004)
    }
  })
  let st = ``;
  let m = rand([0.2,0.01, 0.1,0.2,0.3,0.2,0.1,0.03,0.04,0.5,0.2,0.3])
  let m2 = rand([1,2,3])
  new Array(Math.ceil(20 / sizes[i])).fill().map((_, ri) => {
    new Array(Math.ceil((20 / sizes[i])*0.5)).fill().map((__, ci) =>
{
  st += (modes[0](time, ci * m, ri*m2) < 0.5 ? l[(ci) % letters[i].length] : ' ')
}      
    )
    st += '\n'
  })
  return (
    <group ref={group} rotation={[0, 0, randI(4)*(Math.PI*1)]}>
      <Text
        ref={text}
        font="./IBMPlexMono-Thin.ttf"
        fontSize={textSize * 3 * sizes[i]}
        text={st}
        color={cols[i % cols.length]}
        lineHeight={0.2}
        material={mat}
        letterSpacing={-0.2}
        position={[0, 0, 0.04 * i]}
      />
    </group>
  );
};

let modes = [
  (t, c, r) => ((c + (r + t * 10) ^ c - (r + t * 10)) % 11 & 1) - .1,
]

console.log('%c☁️@ramioso 2022-09-07☁️', 'color: green');
